import React from 'react';
import '../signup progress bar/SignUpProgressBar.css'

const SignUpPregressBar = () => {
    return (
        <div className="progress_bar">
            <ul className="progress_bar__row">
                <li className="text-jost-sb-22 active ">CLUB Details</li>
                <li className="text-jost-sb-22">Golf Courses</li>
                <li className="text-jost-sb-22">Payment DETAILS</li>
                <li className="text-jost-sb-22">Confirmation</li>
            </ul>
        </div>
    );
};

export default SignUpPregressBar;
